import React, { useEffect, useState } from 'react';
import { Bot, X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import MemberAIChat from './MemberAIChat';

const MemberAIWidget = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!user || user === false) setOpen(false);
  }, [user]);

  if (!user || user === false) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[70] flex flex-col items-end gap-3 sm:bottom-6 sm:right-6" data-testid="member-ai-widget">
      <div
        id="member-ai-widget-panel"
        className={`${open ? 'block' : 'hidden'} overflow-hidden rounded-xl border border-white/10 bg-[#0c0a0e] shadow-2xl shadow-black/50`}
        style={{ height: 'min(560px, calc(100dvh - 6.5rem))', width: 'min(380px, calc(100vw - 2rem))' }}
        role="dialog"
        aria-label="Refuel-assistenten"
        aria-hidden={!open}
      >
        <MemberAIChat compact onClose={() => setOpen(false)} />
      </div>
      <button
        type="button"
        data-testid="member-ai-widget-toggle"
        onClick={() => setOpen((current) => !current)}
        aria-label={open ? 'Lukk Refuel-assistenten' : 'Opne Refuel-assistenten'}
        aria-expanded={open}
        aria-controls="member-ai-widget-panel"
        title={open ? 'Lukk AI-chat' : 'Spør Refuel-assistenten'}
        className="flex h-14 w-14 items-center justify-center rounded-full border border-white/15 bg-[#ff2e2e] text-black shadow-lg shadow-black/40 transition hover:bg-[#ff5555] focus:outline-none focus:ring-2 focus:ring-[#ff5555] focus:ring-offset-2 focus:ring-offset-black"
      >
        {open ? <X size={23} /> : <Bot size={24} />}
      </button>
    </div>
  );
};

export default MemberAIWidget;